var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5229 11.9995C22.5229 17.5223 18.0457 21.9995 12.5229 21.9995C7.0001 21.9995 2.52295 17.5223 2.52295 11.9995C2.52295 6.47666 7.0001 1.99951 12.5229 1.99951C18.0457 1.99951 22.5229 6.47666 22.5229 11.9995Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5229 8.99951C15.5229 10.6564 14.1798 11.9995 12.5229 11.9995C10.866 11.9995 9.52295 10.6564 9.52295 8.99951C9.52295 7.34266 10.866 5.99951 12.5229 5.99951C14.1798 5.99951 15.5229 7.34266 15.5229 8.99951Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0229 20.7356C17.5537 21.2106 18.2545 21.4995 19.0229 21.4995C20.6798 21.4995 22.0229 20.1564 22.0229 18.4995C22.0229 17.7311 21.734 17.0303 21.259 16.4995",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02246 20.7356C7.49171 21.2106 6.79082 21.4995 6.02246 21.4995C4.36561 21.4995 3.02246 20.1564 3.02246 18.4995C3.02246 17.7311 3.31132 17.0303 3.78636 16.4995",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5229 17.9995V15.9995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAgent);
export default __webpack_public_path__ + "static/media/icon-agent.0df24a86be62c9190032678d789cf577.svg";
export { ForwardRef as ReactComponent };